// i18n
import translations from 'presentations/views/components/pages/AboutPage/i18n.json';
import { translateInComponent } from 'infras/i18n';

import { GetStaticPropsContext } from 'next';

import MainDocument from 'presentations/views/components/MainDocument';
import AboutPage from 'presentations/views/components/pages/AboutPage';
import { aboutPath, apiPath, webPath } from 'presentations/routes/path';
import { get } from 'infras/rest_client';
import {
  BlogListItem,
  CareerListItem,
} from 'presentations/api/schema/contents';

interface ServerProps {
  linkCanonical: string;
  newsBlogs: BlogListItem[];
  engineeringBlogs: BlogListItem[];
  careerItems: CareerListItem[];
}

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  let newsBlogs = [];
  let engineeringBlogs = [];
  let careerItems = [];
  try {
    const results: any = await Promise.all([
      new Promise(async (resolve, reject) => {
        const result = await get(
          apiPath(`/v1/contents/blogs`, {
            page: 1,
            perPage: 6,
            locale,
            category: 'news',
          }),
        );
        if (!result.isSuccess) {
          reject();
          return;
        }
        resolve(result.data || []);
      }),
      new Promise(async (resolve, reject) => {
        const result = await get(
          apiPath(`/v1/contents/blogs`, {
            page: 1,
            perPage: 6,
            locale,
            category: 'engineering',
          }),
        );
        if (!result.isSuccess) {
          reject();
          return;
        }
        resolve(result.data || []);
      }),
      new Promise(async (resolve, reject) => {
        const result = await get(
          apiPath(`/v1/contents/careers`, {
            locale,
          }),
        );
        if (!result.isSuccess) {
          reject();
          return;
        }
        resolve(result.data || []);
      }),
    ]);
    newsBlogs = results[0];
    engineeringBlogs = results[1];
    careerItems = results[2];
  } catch (error) {
    return { props: { statusCode: 500 } };
  }

  return {
    props: {
      linkCanonical: webPath(aboutPath(), locale),
      newsBlogs,
      engineeringBlogs,
      careerItems,
    },
  };
}

export default function Page(props: ServerProps) {
  const t = translateInComponent(translations);

  return (
    <MainDocument
      title={t('title')}
      description={t('description')}
      linkCanonical={props.linkCanonical}
      isExcludeSiteName
    >
      <AboutPage
        newsBlogs={props.newsBlogs}
        engineeringBlogs={props.engineeringBlogs}
        careerItems={props.careerItems}
      />
    </MainDocument>
  );
}
